import React from 'react';
import { FaTimes } from 'react-icons/fa';
import './UserDetailsModal.css';
import { BASE_URL } from '../../../utils/configConstants';

const UserDetailsModal = ({ user, isOpen, onClose, onImageClick }) => {
  if (!isOpen || !user) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="user-details-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>User Details</h3>
          <button className="modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <div className="user-details-content">
            {/* Basic Information */}
            <div className="detail-row">
              <span className="detail-label">Name:</span>
              <span className="detail-value">{user.name || 'Not available'}</span>
            </div>

            <div className="detail-row">
              <span className="detail-label">Email:</span>
              <span className="detail-value">{user.email || 'Not available'}</span>
            </div>

            <div className="detail-row">
              <span className="detail-label">Phone:</span>
              <span className="detail-value">
                {user.country_code} {user.phoneno || 'Not available'}
              </span>
            </div>

            {/* GST Information */}
            {user.gst_no && (
              <div className="detail-row">
                <span className="detail-label">GST Number:</span>
                <span className="detail-value">{user.gst_no}</span>
              </div>
            )}

            {/* {user.gst && (
              <div className="detail-row">
                <span className="detail-label">GST Document:</span>
                <div className="document-preview">
                  <img
                    src={`${BASE_URL}${user.gst}`}
                    alt="GST Document"
                    onClick={() => onImageClick(`${BASE_URL}${user.gst}`)}
                  />
                </div>
              </div>
            )} */}

            {/* PAN Card Information */}
            {user.pancard_no && (
              <div className="detail-row">
                <span className="detail-label">PAN Number:</span>
                <span className="detail-value">{user.pancard_no}</span>
              </div>
            )}

            {/* {user.pancard && (
              <div className="detail-row">
                <span className="detail-label">PAN Document:</span>
                <div className="document-preview">
                  <img
                    src={`${BASE_URL}${user.pancard}`}
                    alt="PAN Document"
                    onClick={() => onImageClick(`${BASE_URL}${user.pancard}`)}
                  />
                </div>
              </div>
            )} */}

            {/* Passport Information */}
            {user.passport_no && (
              <div className="detail-row">
                <span className="detail-label">Passport Number:</span>
                <span className="detail-value">{user.passport_no}</span>
              </div>
            )}

            {/* {user.passport && (
              <div className="detail-row">
                <span className="detail-label">Passport Document:</span>
                <div className="document-preview">
                  <img
                    src={`${BASE_URL}${user.passport}`}
                    alt="Passport Document"
                    onClick={() => onImageClick(`${BASE_URL}${user.passport}`)}
                  />
                </div>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetailsModal; 